import './Prototypes/_index';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import app, { createReducer } from './reducers';
import { historyMiddleware } from './Middlewares/History.middleware';
import QuickSearch from './Components/QuickSearch';
import Navigation from './Components/Navigation';
import FacetedSearch from './Components/FacetedSearch';
import FacetedSearchCompactContainer from './Components/FacetedSearchCompactContainer';
import DynamicComponent from './Components/DynamicComponent';
import HeaderCartButton from "./Components/HeaderCartButton";
import HeaderFavoritesButton from "./Components/HeaderFavoritesButton";
import HeaderUserButton from "./Components/HeaderUserButton";
import { filterCustomScripts } from './Components/Filter-scripts';

import Subnav from "./VanillaJS/subnav";
import Faqs from "./VanillaJS/faqs";
import ProductPageNav from "./VanillaJS/product-page-nav";
import OrganizationSearch from "./Components/OrganizationSearch";

window.__litium = window.__litium || {};
const preloadState = window.__litium.preloadState || {};
const store = createStore(
    app,
    preloadState,
    composeWithDevTools(applyMiddleware(thunk, historyMiddleware))
);

// Add a dictionary to keep track of the registered async reducers
store.asyncReducers = {};

// Create an inject reducer function
// This function adds the async reducer, and creates a new combined reducer
store.injectReducer = (key, asyncReducer) => {
    if (!store.asyncReducers[key]) {
        store.asyncReducers[key] = asyncReducer;
        store.replaceReducer(createReducer(store.asyncReducers));
    }
};

window.__litium = {
    ...window.__litium,
    bootstrapComponents: () => {
        // bootstrap React components, in case the HTML response we receive from the server
        // has React components. ReactDOM.render performs only an update on previous rendered
        // components and only mutate the DOM as necessary to reflect latest React element.
        bootstrapComponents();
    },
    cache: {}, // for storing cache data for current request
};

const registeredContainers = [];
const renderReact = (element, container, callback) => {
    registeredContainers.push(container);
    ReactDOM.render(element, container, callback);
};

function insertParam(key, value) {
    if (history.pushState) {
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?${key}=${value}`;
        window.history.pushState({path:newurl},'',newurl);
    }
}

/**
 *
 * @param {MouseEvent} e
 * @returns {boolean}
 */
const setUrlTabUrl = function(e) {
    insertParam('currentTab', this.getAttribute('for'))
}

window.onload = function () {
    new Subnav();
    new Faqs();
    new ProductPageNav();

    let tabs = document.querySelectorAll('.my-pages label.tab__header');
    if (tabs.length) {
        tabs.addEventListener('click', setUrlTabUrl)
    }

    filterCustomScripts();

    if(!document.querySelector('.header__seller')) return;
    document.querySelector('body').classList.add('header-height-seller');
};

window.onunload = () => {
    // make sure components are unmounted, redux's listener are unsubscribed
    // to fix issue with iframe navigation in IE
    registeredContainers.forEach((container) => {
        ReactDOM.unmountComponentAtNode(container);
    });
};

/**
 *
 * @param {Event} e
 */
function categoryFilterRendered(e) {
    let subnavCloseButtonEl = document.querySelectorAll('.js-subnav-close');
    if (subnavCloseButtonEl.length) {
        const SubnavCloseButton = DynamicComponent({
            loader: () => import('./Components/SubnavCloseButton'),
        });

        subnavCloseButtonEl.forEach((el) => {
            renderReact(
                <Provider store={store}>
                    <SubnavCloseButton />
                </Provider>,
                el
            );
        })
    }
}

const bootstrapComponents = () => {
    document.addEventListener('categoryFilterRendered', categoryFilterRendered)

    let userButton = document.getElementById('header-user-button');
    if (userButton) {
        let props = JSON.parse(userButton.dataset.props);
        if (('enabled' in props) && props.enabled) {
            renderReact(
                <Provider store={store}>
                    <HeaderUserButton {...props}/>
                </Provider>,
                userButton
            );
        } else {
            userButton.remove();
        }
    }

    let favoritesButton = document.getElementById('header-favorites-button');
    if (favoritesButton) {
        let props = JSON.parse(favoritesButton.dataset.props);
        if (('enabled' in props) && props.enabled) {
            renderReact(
                <Provider store={store}>
                    <HeaderFavoritesButton {...props}/>
                </Provider>,
                favoritesButton
            );
        } else {
            favoritesButton.remove();
        }
    }

    let miniCart = document.querySelector('#header-cart-button');
    if (miniCart) {
        let props = JSON.parse(miniCart.dataset.props);
        if (('enabled' in props) && props.enabled) {
            renderReact(
                <Provider store={store}>
                    <HeaderCartButton {...props}/>
                </Provider>,
                miniCart
            );
        } else {
            miniCart.remove();
        }
    }

    let variantTableSingle = document.querySelector('#variant-table-single');
    if (variantTableSingle) {
        /**
         * @type array
         */
        let variant = __litium.selectedVariant;
        if (typeof variant !== 'undefined' && variant.length)
        {
            const VariantTable = DynamicComponent({
                loader: () => import('./Components/VariantTable/VariantTable'),
            });
            renderReact(
                <Provider store={store}>
                    <VariantTable {...{ variants:variant, ignoreDiscountedFilter: false, isSelectedVariant: true }}/>
                </Provider>,
                variantTableSingle
            );
        }
    }

    let variantTable = document.querySelector('#variant-table');
    if (variantTable) {
        /**
         * @type array
         */
        let variants = __litium.variants;
        if (typeof variants !== 'undefined' && variants.length)
        {
            const VariantTable = DynamicComponent({
                loader: () => import('./Components/VariantTable/VariantTable'),
            });
    
            renderReact(
                <Provider store={store}>
                    <VariantTable {...{ variants, ignoreDiscountedFilter: false }}/>
                </Provider>,
                variantTable
            );
        }
    }

    let accessoriesModal = document.querySelector('#accessories-modal');
    if (accessoriesModal) {
        const AccessoriesModal = DynamicComponent({
            loader: () => import('./Components/VariantTable/AccessoriesModal'),
        });

        renderReact(
            <Provider store={store}>
                <AccessoriesModal />
            </Provider>,
            accessoriesModal
        );
    }

    let quickSearch = document.querySelectorAll('.quick-search');
    if (quickSearch.length) {
        quickSearch.forEach(el  => {
            renderReact(
                <Provider store={store}>
                    <QuickSearch />
                </Provider>,
                el
            );
        })
    }
    if (document.getElementById('navbar')) {
        renderReact(
            <Provider store={store}>
                <Navigation isMainNav={true} />
            </Provider>,
            document.getElementById('navbar')
        );
    }
    if (document.getElementById('facetedSearch')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearch />
            </Provider>,
            document.getElementById('facetedSearch')
        );
    }
    if (document.getElementById('facetedSearchCompact')) {
        renderReact(
            <Provider store={store}>
                <FacetedSearchCompactContainer />
            </Provider>,
            document.getElementById('facetedSearchCompact')
        );
    }
    if (document.getElementById('myPagePersons')) {
        const PersonList = DynamicComponent({
            loader: () => import('./Components/PersonListContainer'),
        });
        renderReact(
            <Provider store={store}>
                <PersonList />
            </Provider>,
            document.getElementById('myPagePersons')
        );
    }
    if (document.getElementById('myPageAddresses')) {
        const AddressList = DynamicComponent({
            loader: () => import('./Components/AddressListContainer'),
        });
        let el = document.getElementById('myPageAddresses');
        renderReact(
            <Provider store={store}>
                <AddressList />
            </Provider>,
            el
        );
    }
    if (document.getElementById('checkout')) {
        const Checkout = DynamicComponent({
            loader: () => import('./Components/Checkout'),
        });
        renderReact(
            <Provider store={store}>
                <Checkout />
            </Provider>,
            document.getElementById('checkout')
        );
    }

    if (document.querySelectorAll('.slider').length > 0) {
        const Slider = DynamicComponent({
            loader: () => import('./Components/Slider'),
        });
        Array.from(document.querySelectorAll('.slider')).forEach(
            (slider, index) => {
                const values = [...slider.querySelectorAll('template')].map(
                    (block) => {
                        return {
                            html: block.innerHTML,
                        };
                    }
                );
                if (values.length > 0) {
                    renderReact(<Slider values={values} />, slider);
                }
            }
        );
    }

    let productImagesCarousel = document.querySelectorAll('.product-images');
    if (productImagesCarousel.length) {
        const ProductImages = DynamicComponent({
            loader: () => import('./Components/ProductImages'),
        });

        productImagesCarousel.forEach(
            (element, index) => {
                const images = [...element.querySelectorAll('template')].map((img) => ({
                    html: img.innerHTML,
                    src: img.dataset.src,
                    thumbnailSrcUrl: img.dataset.thumbnailSrc,
                    extraDescription: img.dataset.extraDescription,
                }));

                if (images.length > 0) {
                    renderReact(<Provider store={store}>
                        <ProductImages images={images} />
                    </Provider>, element);
                }
            }
        );
    }

    let productCarousels = document.querySelectorAll('.product-carousel__carousel');
    if (productCarousels.length) {
        const ProductCarousel = DynamicComponent({
            loader: () => import('./Components/ProductCarousel'),
        });

        productCarousels.forEach(
            (element, index) => {
                const values = [...element.querySelectorAll('template')].map(
                    (block) => {
                        return {
                            html: block.innerHTML,
                        };
                    }
                );

                if (values.length > 0) {
                    renderReact(<Provider store={store}>
                        <ProductCarousel values={values} />
                    </Provider>, element);
                }
            }
        );
    }

    let buyButtons = document.querySelectorAll('buy-button');
    if (buyButtons.length) {
        const BuyButton = DynamicComponent({
            loader: () => import('./Components/BuyButton'),
        });
        buyButtons.forEach(
            (button) => {
                const {
                    articleNumber,
                    quantityFieldId,
                    href,
                    cssClass,
                    label,
                } = button.dataset;
                renderReact(
                    <Provider store={store}>
                        <BuyButton
                            {...{
                                label,
                                articleNumber,
                                quantityFieldId,
                                href,
                                cssClass,
                            }}
                        />
                    </Provider>,
                    button
                );
            }
        );
    }

    if (document.getElementById('orderHistoryPage')) {
        const OrderList = DynamicComponent({
            loader: () => import('./Components/OrderHistoryListContainer'),
        });
        renderReact(
            <Provider store={store}>
                <OrderList />
            </Provider>,
            document.getElementById('orderHistoryPage')
        );
    }

    if (document.getElementById('orderApproverPage')) {
        const OrderApproverList = DynamicComponent({
            loader: () => import('./Components/OrderApproverListContainer'),
        });
        renderReact(
            <Provider store={store}>
                <OrderApproverList />
            </Provider>,
            document.getElementById('orderApproverPage')
        );
    }

    let gridListSwitcherRoot = document.querySelector('grid-list-switcher');
    if (gridListSwitcherRoot) {
        const GridListSwitcher = DynamicComponent({
            loader: () => import('./Components/GridListSwitcher'),
        });

        let containerSelector = gridListSwitcherRoot.dataset.containerSelector;

        renderReact(
            <Provider store={store}>
                <GridListSwitcher {...{ containerSelector }}/>
            </Provider>,
            gridListSwitcherRoot
        );
    }

    let overlay = document.getElementById('overlay');
    if (overlay) {
        const PageOverlay = DynamicComponent({
            loader: () => import('./Components/Overlay'),
        });
        renderReact(
            <Provider store={store}>
                <PageOverlay />
            </Provider>,
            overlay
        );
    }

    let filterTriggerButton = document.getElementById('filter-trigger-button');
    if (filterTriggerButton) {
        const FilterTriggerButton = DynamicComponent({
            loader: () => import('./Components/FilterTriggerButton'),
        });
        renderReact(
            <Provider store={store}>
                <FilterTriggerButton />
            </Provider>,
            filterTriggerButton
        );
    }

    let categoryTriggerButton = document.getElementById('category-trigger-button');
    if (categoryTriggerButton) {
        const CategoryTriggerButton = DynamicComponent({
            loader: () => import('./Components/CategoryTriggerButton'),
        });
        renderReact(
            <Provider store={store}>
                <CategoryTriggerButton />
            </Provider>,
            categoryTriggerButton
        );
    }

    let favoriteList = document.getElementById('favorite-list');
    if (favoriteList) {
        const FavoriteList = DynamicComponent({
            loader: () => import('./Components/Favorites/FavoritesList'),
        });

        renderReact(
            <Provider store={store}>
                <FavoriteList />
            </Provider>,
            favoriteList
        );
    }

    let retryTimeout = 0;
    let retryTimeoutDuration = 500;
    retryTimeout = setInterval(() => {
        let categoryFilterReact = document.getElementById('category-filter-react');
        if (categoryFilterReact) {
            let subNav = categoryFilterReact.querySelector('nav.subnav');

            if (subNav) {
                clearInterval(retryTimeout);

                const CategoryFilter = DynamicComponent({
                    loader: () => import('./Components/CategoryFilter'),
                });

                renderReact(
                    <Provider store={store}>
                        <CategoryFilter filterElement={subNav.parentElement}/>
                    </Provider>,
                    categoryFilterReact
                );
            }
        }
    }, retryTimeoutDuration);

    let jsFilterBrand = document.querySelectorAll('.js-filter-brands');
    if (jsFilterBrand.length > 0) {
        const brandItems = document.querySelectorAll('.brands-list > li');
        Array.from(jsFilterBrand).forEach((brandSelector) => {
            brandSelector.addEventListener('click', () => {
                brandItems.forEach((brand) => {
                    brand.classList.add('hidden');
                })
                document.querySelectorAll('.brands-list > li.js-lettergroup-' + brandSelector.dataset.letter + '').forEach((letterGroup) => {
                    letterGroup.classList.remove('hidden');
                })
            });
        });
    }


    let searchResultCategories = document.querySelector('#search-result-categories');
    if (searchResultCategories) {
        const SearchResultCategories = DynamicComponent({
            loader: () => import('./Components/SearchResultCategories'),
        });

        renderReact(
            <Provider store={store}>
                <SearchResultCategories categoriesResult={window.__litium.categoriesResult}/>
            </Provider>,
            searchResultCategories
        );
    }

    if (document.getElementById('organizationSearch')) {
        renderReact(
          <Provider store={store}>
            <OrganizationSearch />
          </Provider>,
          document.getElementById('organizationSearch'),
        );
    }
};

bootstrapComponents();